import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import MediaPlyr, { PlyrProps } from '@/components/base/media-plyr'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'

import { videoBlockRevealAnimation } from './animations'

export type VideoBlockProps = HTMLAttributes<HTMLDivElement> &
  Partial<PlyrProps>

const VideoBlock = ({
  poster,
  video,
  youtube,
  video_type,
  ...props
}: VideoBlockProps) => {
  return (
    <Motion animation={videoBlockRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid>
              <div className="col-span-2 md:col-span-6 lg:col-span-7 lg:col-start-3 xl:col-span-6 xl:col-start-3">
                <div
                  className="relative aspect-video rounded-radius-rounded bg-surface-accent-light dark:bg-surface-accent-dark/10"
                  data-motion-media
                >
                  <MediaPlyr
                    video={video}
                    poster={poster}
                    youtube={youtube}
                    video_type={video_type}
                    use_video={true}
                    className="rounded-radius-rounded"
                  />
                </div>
              </div>
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default VideoBlock
